module.exports = __webpack_public_path__ + "img/download_guide.5bdc5833.png";